'use client';

import { useEffect, useState } from 'react';

/**
 * Returns whether the given media query matches. SSR-safe: returns false during SSR
 * and updates when the query match state changes (e.g. on resize).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}
